import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { InputText } from "primereact/inputtext";
import {
  GeneratePaymentLink,
} from "../../services/PaymentGatewayConfig/PaymentGatewayConfig";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { getLocalStorePaymentGatewayConfig } from "../../utils/localStorage";

const PaymentGatewayLinkCreateModal = ({
  paymentGatewayLinkCreateModalVisible,
  setPaymentGatewayLinkCreateModalVisible,
  receiveAmountValue,
  storeCustomerId,
  storeId,
  brandId,
  storeUserId,
  bookingOrderId,
}) => {

  const navigate = useNavigate();
  const [responseData, setResponseData] = useState({});
  const [amountData, setAmountData] = useState("");
  const [errorText, setErrorText] = useState("");
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);
  const [storePaymentGatewayData, setStorePaymentGatewayData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

   const fetchLocalStorePaymentGatewayConfig = async () => {
        const { storePaymentGatewayConfig } = getLocalStorePaymentGatewayConfig();
        if (
          storePaymentGatewayConfig &&
          Object.keys(storePaymentGatewayConfig).length > 0
        ) {
          setStorePaymentGatewayData(storePaymentGatewayConfig);
        } else {
          setStorePaymentGatewayData([]);
        }
      };

  useEffect(() => {
    fetchLocalStorePaymentGatewayConfig();
  }, []);

 
  const handleCollectPayment = () => {
    if (!isPayNowButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsPayNowButtonPressed(true);
      const gatewayData = {
        storeGatewayId: storePaymentGatewayData[0]?.id,
        storeCustomerId: storeCustomerId,
        orderId: bookingOrderId,
        requestAmount: receiveAmountValue,
        notify: false,
        storeUserId: storeUserId,
        forceCreate: true,
      };
      GeneratePaymentLink(gatewayData)
        .then(response => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res.paymentLink !== '') {
              setResponseData(Res);
              handlePaymentLinkPress(Res.paymentLink);
              navigate('/ThankYou', {state: {
                storeCustomerId: storeCustomerId,
                bookingOrderId: bookingOrderId,
              }});
              setIsPayNowButtonPressed(false);
            } else {
              setIsPayNowButtonPressed(false);
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const handleModalClose = () => {
    setPaymentGatewayLinkCreateModalVisible(false);
          setIsPayNowButtonPressed(false);
  };

  const handlePaymentLinkPress = paymentLink => {
    window.open(paymentLink, '_blank');
    setPaymentGatewayLinkCreateModalVisible(
      !paymentGatewayLinkCreateModalVisible,
    );
    setIsPayNowButtonPressed(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={paymentGatewayLinkCreateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!paymentGatewayLinkCreateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={"images/cashless-payment.png"}
                  style={{
                    width: 50,
                    // height: 40,
                  }}
                />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Payment Link
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            {Object.keys(responseData).length > 0 ? (
              <div className="mx-3 my-2">
                <p
                  className="text-2xl font-semibold text-center"
                  style={{ color: "red" }}
                >
                  {responseData.status
                    ? "Payment Link Create Please check Notifications"
                    : responseData.paymentLink !== ""
                    ? "Payment Link is already Created"
                    : "Payment Link Failed"}
                </p>
              </div>
            ) : (
              <div className="flex flex-column">
                <div >
                  <p className="text-2xl font-semibold text-center">
                    {
                      storePaymentGatewayData[0]?.brandPaymentGatewayInfo
                        .gatewayName
                    }
                  </p>
                </div>

                <div className=" mx-4">
                  <div>
                    <p>Amount</p>
                    <InputText
                      className="w-full text-xl h-3rem border-round-xl shadow-2"
                      style={{
                        backgroundColor: "#fff",
                      }}
                      disabled={true}
                      value={receiveAmountValue}
                      keyboardType="numeric"
                    />
                  </div>
                  {errorText !== "" && <p>{errorText}</p>}
                </div>

                {responseData.paymentLink ? (
                  <Button
                  className="mt-3 mb-3 mx-4 border-round-xl flex-1 "
                  onClick={() => handlePaymentLinkPress(responseData.paymentLink)}
                  disabled={isPayNowButtonPressed}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    {responseData.paymentLink}
                  </p>
                </Button>
            ) : (
              <Button
                  className="mt-3 mb-3 mx-4 border-round-xl flex-1 "
                  onClick={handleCollectPayment}
                  disabled={isPayNowButtonPressed}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    Generate Payment Link
                  </p>
                </Button>
            )}
                
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default PaymentGatewayLinkCreateModal;
